'use client';

import { c as _c } from "react/compiler-runtime";
import { type Rule } from '@shared/all/domains/spaces';
import { ChevronDown, ChevronUp, Clock } from 'lucide-react';
import { useState } from 'react';
import RuleHistoryModal from './RuleHistoryModal';
type Props = {
  editClickHandler: () => void;
  isOwner: boolean;
  index: number;
};
const RuleItem = t0 => {
  const $ = _c(33);
  const {
    id,
    title,
    description,
    editClickHandler,
    isOwner,
    edited,
    index
  } = t0;
  const [open, setOpen] = useState(false);
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const t1 = `mx-2 rounded border-2 border-ds-border-subtle px-2 py-3 text-sm hover:bg-background-light ${open && "bg-background-secondary"}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setOpen(_temp);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = index + 1;
  let t4;
  if ($[1] !== t3 || $[2] !== title) {
    t4 = <p className="text-base">{t3}. {title}</p>;
    $[1] = t3;
    $[2] = title;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== description || $[5] !== open) {
    t5 = open && <p className="mt-1 text-sm text-textSecondary">{description}</p>;
    $[4] = description;
    $[5] = open;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div>{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== editClickHandler || $[11] !== isOwner) {
    t7 = isOwner && <span className="mr-3 cursor-pointer capitalize text-textSecondary hover:underline" onClick={editClickHandler}>edit</span>;
    $[10] = editClickHandler;
    $[11] = isOwner;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== edited) {
    t8 = edited && <Clock className="mr-1.5" size={13} onClick={() => setHistoryModalOpen(true)} />;
    $[13] = edited;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== open) {
    t9 = open ? <ChevronUp /> : <ChevronDown />;
    $[15] = open;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
    t10 = <div className="flex items-center">{t7}{t8}{t9}</div>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t6) {
    t11 = <div className="flex cursor-pointer justify-between gap-x-4 font-emphasis" onClick={t2}>{t6}{t10}</div>;
    $[21] = t10;
    $[22] = t6;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t1 || $[25] !== t11) {
    t12 = <div className={t1}>{t11}</div>;
    $[24] = t1;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== historyModalOpen || $[28] !== id) {
    t13 = historyModalOpen && <RuleHistoryModal closeHandler={() => setHistoryModalOpen(false)} ruleId={id} />;
    $[27] = historyModalOpen;
    $[28] = id;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t12 || $[31] !== t13) {
    t14 = <>{t12}{t13}</>;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
};
export default RuleItem;
function _temp(x) {
  return !x;
}